// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"9c0068f8","796":"e98b5056"}[chunkId] + ".chunk.js";
};